<sc-master-detail [readOnly]="!manageArticleTypePermitted" [data]="data" [selection]="[selected]" [showDelete]="false" (selectionChanged)="onSelectionChanged($event);"
      (addEntry)="onAddEntry($event);">

      <sc-padding [fitHeight]="true" *ngIf="selected">
          <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
            <div>
              <sc-flex [centered]="true">
              <sc-title>
                  {{ 'Artikeltyp' | translate: ['erp.ui.articletype.title', translationService.language]}}
              </sc-title>
              <sc-content-spacer [grow]="true"></sc-content-spacer>
                  <button mat-stroked-button (click)="onCancel()">
                      <mat-icon><sc-icon iconClass="fa-xmark"></sc-icon></mat-icon>
                      {{ 'abbrechen' | translate: ['erp.ui.articletype.action.cancel',
                      translationService.language]}}
                  </button>
                  <sc-content-spacer></sc-content-spacer>
                  <button mat-flat-button (click)="onSave()" [disabled]="saveDisabled()">
                      <mat-icon><sc-icon iconClass="fa-save"></sc-icon></mat-icon>
                      {{ 'speichern' | translate: ['erp.ui.articletype.action.save',
                      translationService.language]}}
                  </button>
                </sc-flex>
            </div>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-bordered-tile>
                  <sc-padding>
                      <app-article-type-masterdata [articleType]="selected"></app-article-type-masterdata>
                  </sc-padding>
              </sc-bordered-tile>
              <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
              <sc-flex-fitting-content [vertical]="true">
                  <sc-scroll-pane>
                      <sc-sub-title>
                          {{ 'Attribute' | translate: ['erp.ui.articletype.subtitle.attributes', translationService.language]}}
                          <sc-content-spacer [grow]="true"></sc-content-spacer>
                          <button mat-stroked-button (click)="addAttributeGroup()">
                              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                              {{ 'add Group' | translate: ['erp.ui.articletype.action.add-group', translationService.language]}}
                          </button>
                          <sc-content-spacer *ngIf="selected.attributeGroups.length > 0"></sc-content-spacer>
                          <button mat-stroked-button (click)="addAttribute()" *ngIf="selected.attributeGroups.length > 0">
                              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                              {{ 'add Attribute' | translate: ['erp.ui.articletype.action.add-attribute', translationService.language]}}
                          </button>
                      </sc-sub-title>
                      <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                      <sc-bordered-tile>
                          <app-article-type-attribute-list [articleType]="selected"
                              [editAttributeGroupFunction]="editAttributeGroup" [removeAttributeGroupFunction]="removeAttributeGroup"
                              [editAttributeFunction]="editAttribute" [removeAttributeFunction]="removeAttribute"></app-article-type-attribute-list>
                      </sc-bordered-tile>
                      <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
                      <sc-sub-title>
                          {{ 'Berechnungsregeln' | translate: ['erp.ui.articletype.subtitle.calculationrules', translationService.language]}}
                          <sc-content-spacer [grow]="true"></sc-content-spacer>
                          <button mat-stroked-button (click)="addCalculationRule()">
                              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                              {{ 'add' | translate: ['erp.ui.articletype.action.add-calculationrule', translationService.language]}}
                          </button>
                      </sc-sub-title>
                      <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                      <sc-bordered-tile>
                          <app-article-type-calculation-rule-list [articleType]="selected" [calculationRules]="selected?.calculationRules"
                              [editCalculationRuleFunction]="editCalculationRule" [removeCalculationRuleFunction]="removeCalculationRule">
                          </app-article-type-calculation-rule-list>
                      </sc-bordered-tile>
                      <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
                      <sc-sub-title>
                          {{ 'Basisartikeldefinitionen' | translate: ['erp.ui.articletype.subtitle.basicarticledefinition', translationService.language]}}
                          <sc-content-spacer [grow]="true"></sc-content-spacer>
                          <button mat-stroked-button (click)="editBaseArticleDefinition()">
                              <mat-icon><sc-icon iconClass="fa-pencil"></sc-icon></mat-icon>
                              {{ 'add' | translate: ['erp.ui.articletype.action.change-basicarticledefinition', translationService.language]}}
                          </button>
                      </sc-sub-title>
                      <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                      <sc-bordered-tile>
                          <app-article-type-base-article-definition-list [definition]="selected?.completeArticleType?.basicArticleDefinition">
                          </app-article-type-base-article-definition-list>
                      </sc-bordered-tile>
                      <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

                  </sc-scroll-pane>
              </sc-flex-fitting-content>
          </sc-flex>
      </sc-padding>

  </sc-master-detail>
